// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_is-array.js
// module id = ../../../../core-js/modules/_is-array.js
// module chunks = 0